import axiosInstance from '@/api/axiosInstance';

const actions = {
  async fetchList({ commit }, queryParams) {
    try {
      const url = '/configurations/list';
      const params = new URLSearchParams(queryParams);
      const response = await axiosInstance.get(`${url}?${params.toString()}`);

      if (response?.status === 200 && response?.data?.data) {
        const configurations = response.data.data.configurations || {};
        const list = configurations.list || [];
        const pagination = configurations.pagination || {};

        if (Array.isArray(list) && (list.length === 0 || pagination.page === 1)) {
          commit('INIT_STATE');
        }

        commit('SET_DATA', { key: 'list', data: list });
        commit('SET_DATA', { key: 'pagination', data: pagination });
      } else {
        throw new Error('No se pudo obtener el listado de configuraciones');
      }
    } catch (error) {
      console.error('Error al obtener el listado de configuraciones:', error);
    }
  },
  async submitForm({ commit }, formData) {
    try {
      const url = '/configurations/save';
      const payload = { ...formData };
      const response = await axiosInstance.post(url, payload);

      if (response?.status === 200) {
        const data = response.data;
        commit('SET_DATA', { key: 'formSend', data: true });

        return data;
      } else {
        throw new Error('No se pudo actualizar la configuración');
      }
    } catch (error) {
      console.error('Error al actualizar la configuración:', error);
      throw error;
    }
  },
};

export default actions;
